import { Facebook, Phone } from "lucide-react";
import { FACEBOOK_URL, PHONE_DISPLAY, PHONE_HREF, TOWNS } from "./content";

export const Footer = () => (
  <footer className="bg-[var(--ink)] text-white" data-testid="site-footer">
    <div className="mx-auto grid max-w-6xl gap-7 px-4 py-10 sm:px-6 md:grid-cols-3">
      <div>
        <p className="font-display text-xl font-bold">Dellsjö Städ & Trädgårdsservice</p>
        <p className="mt-2 text-white/75">Städning för företag, BRF:er och fastighetsägare.</p>
      </div>
      <div>
        <p className="text-sm font-semibold uppercase tracking-[0.12em] text-[#ff9a9e]">Kontakt</p>
        <a href={PHONE_HREF} className="mt-3 flex items-center gap-2 font-semibold hover:underline" data-testid="footer-phone-link">
          <Phone size={16} aria-hidden /> {PHONE_DISPLAY}
        </a>
        <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="mt-2 flex items-center gap-2 hover:underline" data-testid="footer-facebook-link">
          <Facebook size={16} aria-hidden /> Facebook
        </a>
      </div>
      <div>
        <p className="text-sm font-semibold uppercase tracking-[0.12em] text-[#ff9a9e]">Serviceområden</p>
        <p className="mt-3 text-white/85" data-testid="footer-areas">{TOWNS.join(" · ")}</p>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-6xl flex-col gap-1 px-4 py-4 text-sm text-white/65 sm:px-6 md:flex-row md:items-center md:justify-between">
        <p>© 2026 Dellsjö Städ & Trädgårdsservice.</p>
        <a href="https://elido.nu/" target="_blank" rel="noopener noreferrer" className="font-medium text-white/80 underline-offset-4 hover:underline">
          Hemsida av Elido
        </a>
      </div>
    </div>
  </footer>
);
